<template>
  <CRow class="mb-3">
    <CCol>
      <div>
        <CRow>
          <CCol 
            tag="label"
            sm="3"
            class="col-form-label font-bold">
            Время работы
          </CCol>
          <CCol>
            <CButton color="primary" class="mr-3" @click="create">
              Добавить
            </CButton>
          </CCol>
        </CRow>
        <CCardBody>
          <CRow class="pl-3 pb-3" />
          <div class="table-responsive">
            <table class="table m-0">
              <thead>
                <tr>
                  <th>Начало работы</th>
                  <th>Окончание работы</th>
                  <th>Круглосуточно</th>
                  <th>Активен</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in slots" :key="item.id">
                  <td>{{ scheduleFormated(item.open_weekday, item.open_hours, item.open_minutes) }}</td>
                  <td>{{ scheduleFormated(item.close_weekday, item.close_hours, item.close_minutes) }}</td>
                  <td>
                    <CBadge :color="getBadge(item.around_the_clock)">
                      &nbsp;{{item.around_the_clock ? 'Да' : 'Нет' }}&nbsp;
                    </CBadge>
                  </td>
                  <td>
                    <CBadge :color="getBadge(item.enabled)">
                      &nbsp;{{item.enabled ? 'Да' : 'Нет' }}&nbsp;
                    </CBadge>
                  </td>
                  <td  align="right">
                    <CButton @click="edit(item)">
                      <CIcon :content="$options.icons.cilPencil" class="handle"></CIcon>
                    </CButton>
                  </td>
                  <td>
                    <CButton @click="removeItem(item)">
                      <CIcon :content="$options.icons.cilTrash" class="handle"></CIcon>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>
      </div>
    </CCol>

        <CModal
            :show.sync="editModal"
            title="Время работы"
            width="100%"
        >
                    <CForm>
                        <CRow>
                            <CCol>
                                <h3 class="font-bold">Время открытия</h3>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol cols="6">
                                <CSelect
                                    v-model="editSchedule.open_weekday"
                                    label="День недели"
                                    :options="weekdays"
                                    item-text="title"
                                    item-value="value"
                                    outlined
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.open_hours"
                                    outlined
                                    label="Часы"
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.open_minutes"
                                    outlined
                                    label="Минуты"
                                    hide-details
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol>
                                <h3 class="font-bold">Время закрытия</h3>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol cols="6">
                                <CSelect
                                    v-model="editSchedule.close_weekday"
                                    label="День недели"
                                    :options="weekdays"
                                    item-text="title"
                                    item-value="value"
                                    outlined
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.close_hours"
                                    outlined
                                    label="Часы"
                                    hide-details
                                />
                            </CCol>
                            <CCol cols="3">
                                <CInput
                                    v-model="editSchedule.close_minutes"
                                    outlined
                                    label="Минуты"
                                    hide-details
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol class="flex mt-1 mb-1">
                                <span class="mr-2">Круглосуточно</span>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="editSchedule.around_the_clock"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol class="flex mt-1 mb-1">
                                <span class="mr-2">Активен</span>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="editSchedule.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                <br>
                <div slot="footer">
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="removeModal"
                    >Удалить</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="editModal = false"
                    >Отмена</CButton>
                </div>
        </CModal>
    </CRow>
</template>

<script>
    import { cilPlus, cilTrash, cilPencil } from '@coreui/icons';

    export default {
        name: 'WorkingHours',

        icons: {
            cilPlus,
            cilTrash,
            cilPencil
        },

        props: {
            workingHours: {
                type: Array,
                default: () => []
            },
            serviceType: {
                type: String,
                default: ''
            },
        },

        data() {
            return {
                isAuthorized: false,
                editModal: false,
                editSchedule: {},
                weekdays: [
                    { value: 1, label: 'понедельник' },
                    { value: 2, label: 'вторник' },
                    { value: 3, label: 'среда' },
                    { value: 4, label: 'четверг' },
                    { value: 5, label: 'пятница' },
                    { value: 6, label: 'суббота' },
                    { value: 0, label: 'воскресенье' },
                ],
                slots: [],
            };
        },

        async mounted() {

        },

        watch: {
            workingHours: function () {
                this.setModel();
            },
        },

        created() {
            this.setModel();
        },

        methods: {
            setModel() {
                this.slots = this.workingHours;
            },
            create() {
                this.editSchedule = {
                    entity_id: +this.$route.params.id,
                    open_weekday: 0,
                    open_hours: 0,
                    open_minutes: 0,
                    close_weekday: 0,
                    close_hours: 0,
                    close_minutes: 0,
                    enabled: false,
                    around_the_clock: false,
                    sort: 0,
                    id: null,
                };
                this.editModal = true;
            },
            edit(item) {
                this.editSchedule = JSON.parse(JSON.stringify(item));
                this.editModal = true;
            },
            scheduleFormated(weekDay, hours, minutes) {
                weekDay = this.weekdays.find((item) => item.value === weekDay).label;
                if (hours < 10) {
                    hours = `0${hours}`;
                }
                if (minutes < 10) {
                    minutes = `0${minutes}`;
                }
                return `${weekDay} - ${hours}:${minutes}`;
            },
            async save() {
                try {
                    this.editSchedule.entity_type = this.serviceType;
                    this.editSchedule.open_weekday = +this.editSchedule.open_weekday;
                    this.editSchedule.open_hours = +this.editSchedule.open_hours;
                    this.editSchedule.open_minutes = +this.editSchedule.open_minutes;
                    this.editSchedule.close_weekday = +this.editSchedule.close_weekday;
                    this.editSchedule.close_hours = +this.editSchedule.close_hours;
                    this.editSchedule.close_minutes = +this.editSchedule.close_minutes;
                    this.editSchedule.enabled = !!this.editSchedule.enabled;
                    this.editSchedule.around_the_clock = !!this.editSchedule.around_the_clock;

                    if (this.editSchedule && this.editSchedule.id) {
                        await this.axios.put(`/working-hours/${+this.editSchedule.id}`, this.editSchedule);
                    } else if (this.editSchedule) {
                        delete this.editSchedule.id;
                        await this.axios.post('/working-hours', this.editSchedule);
                    }
                    this.$emit('working-hours-update');
                    this.editModal = false;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения. ' + err);
                }
            },
            async removeModal() {
                try {
                    if (this.editSchedule && this.editSchedule.id) {
                        await this.axios.delete(`/working-hours/${this.editSchedule.id}`);
                        this.editModal = false;
                        this.$emit('working-hours-update');
                    }
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка удаления. ' + err);
                }
            },
            removeItem(item) {
                this.editSchedule = item;
                this.removeModal();
            },
            getBadge (status) {
                return status ? 'success' : 'secondary'
            },
        },
    };
</script>
<style scoped>
    .working-hours_fix-table {
        padding-right: 30px;
    }

    @media (max-width: 767px) {
        .table-responsive {
            overflow-x: auto;
        }
    }

    .table {
        width: 50% !important;
    }
</style>